<template>
    <div>
        <div class="header">
            <img class="logo" src="../assets/image/logo.png" alt="" />
            <!-- <img class="search" @click="showPopup" src="../assets/image/search.png" alt="" /> -->
            <!-- <van-popup :style="{width:'100%'}" v-model="show" position="top">
                <div class="serch_input">
                    <van-search v-model="value" @cancel="onCancel" @search="onSearch" show-action
                        placeholder="请输入搜索关键词" />
                </div>
            </van-popup> -->
        </div>

        <div class="barner">
            <img src="../assets/image/banner.jpg" alt="" />
        </div>
        <div class="content">
            <div class="title" v-if="title_code == 1">
                <span class="title_common title_one active" @click="qiehuan(1)">作品列表</span>
                <span class="title_common title_two" @click="qiehuan(0)">公告通知</span>
                <div class="order">
                    <select name="order" id="order" @change="onChangeOrder">
                        <option value="">时间排序</option>
                        <option value="praise_desc">点赞排序</option>
                    </select>
                </div>

                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                        <div id="course" v-for="(item,i) in list" class="liebiao" @click="tiaozhuan(item.id)">
                            <div style="width: 1.42rem; height: 0.94rem;overflow: hidden;">
                                <img style="width: 100%; height: 100%;" :src="apiUrl + item.cover_img" alt="">
                            </div>
                            <div class="list_contont">
                                <p class="list_title">{{item.title | ellipsis(11)}}</p>
                                <p class="list_bianhao"><span>作品编号：A{{item.number}}</span></p>
                                <div class="piao">
                                    <p class="list_piao" style="float: left;">得票数：<span>{{item.praise}}票</span></p>
                                    <p>
                                        <button style="float: right;" @click="praise(item.id,i)"
                                            :class="item.active?'button_dian':'button'">{{item.active?'已点赞':'为他点赞'}}
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </div>
            <div class="title" v-else>
                <span class="title_common title_one" @click="qiehuan(1)">作品列表</span>
                <span class="title_common title_two active" @click="qiehuan(0)">公告通知</span>

                <van-pull-refresh v-model="notice_refreshing" @refresh="no_onRefresh">
                    <van-list v-model:loading="notice_loading" :finished="notice_finished" finished-text="没有更多了"
                        @load="no_onLoad">

                        <div class="liebiao" v-for="no_item in notice" @click="noticeInfo(no_item.id)">
                            <div class="gg_liebiao">
                                <p>{{no_item.title|ellipsis(21)}}</p>
                                <div>
                                    <p style="width: 2.6rem;height:0.175rem;overflow: hidden;">
                                        {{no_item.message|ellipsis(20)}}</p>
                                    <p style="float: right;">{{no_item.create_time * 1000|fmtDate('yyyy-MM-DD')}}</p>
                                </div>
                            </div>
                        </div>

                    </van-list>
                </van-pull-refresh>

            </div>

        </div>

    </div>
</template>

<script>
    import * as util from "@/utils/network";
    import { Toast } from "vant";
    import { createApp } from 'vue';
    import { List } from 'vant';
    // const config = require("../../WebConfig");

    export default {
        data() {
            return {
                show: false,
                title_code: 1,
                title: '',
                order: '',
                list: [],
                value: '',
                loading: false,
                finished: false,
                refreshing: false,
                course_page: 1,

                notice: [],
                notice_page: 1,
                notice_loading: false,
                notice_finished: false,
                notice_refreshing: false,

            };
        },

        mounted: function () {
            if (localStorage.getItem('time') < (new Date().getTime())) {
                window.localStorage.clear()
            }

            // this.getCourse(); //需要触发的函数
            this.getNotice(); //需要触发的函数
        },
        //手机端返回时滚动条位置
        beforeRouteLeave(to, from, next) {
            this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
            next()
        },
        //进入该页面时，用之前保存的滚动位置赋值
        beforeRouteEnter(to, from, next) {
            next(vm => {
                document.body.scrollTop = vm.scrollTop
            })
        },
        methods: {
            qiehuan(m) {
                this.title_code = m;
            },
            onCancel() {
                this.show = false;
            },
            onSearch() {
                this.title = this.value
                this.list = []
                this.course_page = 1
                this.getCourse();
                this.show = false;
                this.loading = true;
            },
            onChangeOrder() {
                var order = document.getElementById('order');
                this.order = order['value']
                this.list = []
                this.course_page = 1
                this.getCourse();
                this.loading = true;
            },
            showPopup() {
                this.show = true;
            },
            tiaozhuan(id) {
                console.log(22)

                let that = this;
                that.$router.push({
                    path: '/course',
                    query: {
                        id: id
                    }
                })
            },
            noticeInfo(id) {
                let that = this;
                that.$router.push({
                    path: '/noticeInfo',
                    query: {
                        id: id
                    }
                })
            },
            praise:function(id, key) {
                event.stopPropagation()
                event.preventDefault() 
                console.log(111)
                let that = this;
                // var is_praise = that.commonApi.getCookie(id);
                // if (is_praise) {
                //     Toast('此作品已投过票');
                //     return false;
                // }
                // let num = (that.commonApi.getCookie('num')) ? parseInt(that.commonApi.getCookie('num')) : 0;

                var is_praise = localStorage.getItem(id);
                if (is_praise) {
                    Toast('此作品已投过票');
                    return false;
                }

                let num = (localStorage.getItem('num')) ? parseInt(localStorage.getItem('num')) : 0;

                if (num >= 3) {
                    Toast('只允许投三票');
                    return false;
                }
                //发送请求
                util.get('/course/praise', {
                    id: id
                },
                    function (result) {
                        localStorage.setItem(id, 1);
                        localStorage.setItem('num', num + 1);
                        localStorage.setItem('time', (new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)).getTime());

                        // that.commonApi.setCookie(id, 1, 1);
                        // that.commonApi.setCookie('num', num + 1, 1);
                        that.list[key].active = true
                        that.list[key].praise = that.list[key].praise + 1
                        Toast(result.msg);

                    }
                )
            },
            getCourse() {
                let that = this;
                util.post(
                    '/course/index',
                    {
                        page: that.course_page,
                        title: that.title,
                        order: that.order,
                    },
                    function (result) {
                        result.data.data.forEach((item, index) => {
                            // if (that.commonApi.getCookie(item.id) == 1) {
                            if (localStorage.getItem(item.id) == 1) {
                                item.active = true
                            } else {
                                item.active = false
                            }

                        });
                        setTimeout(() => {
                            if (that.refreshing) {
                                that.list = [];
                                that.refreshing = false;
                            }
                            if (result.data.data.length !== 0) {
                                that.course_page = that.course_page + 1
                                let arry = that.list.concat(result.data.data) //前提是livehose是数组
                                that.list = arry
                            } else {
                                that.finished = true;
                            }
                            that.loading = false;
                        }, 800);
                    }
                )
            },
            onLoad() {
                this.getCourse()
            },
            onRefresh() {
                // 清空列表数据
                this.finished = false;

                // 重新加载数据
                this.course_page = 1;
                this.list = []
                this.order = [];
                this.praise = [];
                this.value = '';
                this.title = '';
                var order = document.getElementById('order');
                order[0].selected = true;//设置option第4个元素，即value="3"为默认选中
                this.loading = true;
                this.onLoad();

            },

            //新闻列表
            getNotice() {
                let that = this;
                util.get('/index/notice', {
                    page: that.notice_page
                },
                    function (result) {
                        // result.data.data.forEach((item, index) => {
                        //     item.cover_img = config.PROXYROOT + item.cover_img
                        // });
                        setTimeout(() => {
                            if (that.notice_refreshing) {
                                that.notice = [];
                                that.notice_refreshing = false;
                            }
                            if (result.data.data.length !== 0) {
                                that.notice_page = that.notice_page + 1
                                that.notice = that.notice.concat(result.data.data)
                            } else {
                                that.notice_finished = true;
                            }
                            that.notice_loading = false;

                        }, 800);
                    }
                )
            },
            no_onLoad() {
                this.getNotice()
            },
            no_onRefresh() {
                // 清空列表数据
                this.notice_finished = false;
                // 重新加载数据
                this.notice_page = 1;
                this.notice = []
                this.notice_loading = true;
                this.no_onLoad();

            },
        },
    };
</script>
<style>
    @import "../assets/css/index.css";
</style>


// WEBPACK FOOTER //
// src/components/index.vue